module.exports = __webpack_public_path__ + "images/price-gains-e4a39fc1.svg";